export default __webpack_public_path__ + "static/media/waning-gibbous.a23fd9f9.svg";